import { createFileRoute } from "@tanstack/react-router";
import { ServiceDetailPage, serviceDetailHead } from "@/components/site/ServiceDetailPage";
import { serviceDetails } from "@/lib/service-details";

const service = serviceDetails.find((s) => s.slug === "quickbooks-xero")!;

export const Route = createFileRoute("/services/quickbooks-xero")({
  head: () => serviceDetailHead(service),
  component: () => <ServiceDetailPage service={service} />,
});
